import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Heart, Fish } from 'lucide-react';
import useCartStore from '../store/cartStore';
import { addToWishList } from '../api/userAPI';
import { useStoreSettings } from '../context/StoreSettingsContext';
import toast from 'react-hot-toast';
import './ProductCard.css';

const MEAT_NAMES = ['premium meat', 'meat', 'lamb', 'beef', 'chicken'];
const isMeatProduct = (p) => MEAT_NAMES.some(n => p?.category?.name?.toLowerCase().includes(n));

const ProductCard = ({ product }) => {
  const { settings, showPrice, canAddToCart, isLoggedIn } = useStoreSettings();
  const { addToCart } = useCartStore();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      window.location.href = 'https://app.auroragh.com/login';
      return;
    }
    await addToCart(product.id, 1);
  };

  const handleAddToWishlist = async (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      window.location.href = 'https://app.auroragh.com/login';
      return;
    }
    try {
      await addToWishList(product.id);
      toast.success('Added to wishlist');
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to add to wishlist'
      );
    }
  };

  const getClassBadge = (productClass) => {
    switch (productClass) {
      case 'FIRST': return { label: 'First Class', className: 'badge-first' };
      case 'BUSINESS': return { label: 'Business', className: 'badge-business' };
      default: return { label: 'Economy', className: 'badge-economy' };
    }
  };

  const classBadge = getClassBadge(product.productClass);

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-image-wrapper">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            className="product-image"
          />
        ) : (
          <div className="product-image-placeholder">
            <Fish size={48} color="#29ABE2" strokeWidth={1} />
          </div>
        )}
        <span className={`class-badge ${classBadge.className}`}>
          {classBadge.label}
        </span>
        {product.label && (
          <span className="product-label-badge">{product.label}</span>
        )}
        <button className="wishlist-btn" onClick={handleAddToWishlist}>
          <Heart size={16} />
        </button>
      </div>

      <div className="product-info">
        <p className="product-category">{product.category?.name}</p>
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.description}</p>

        <div className="product-footer">
          <div className="product-price">
            {showPrice ? (
              <>
                <span className="currency">
                  {settings.currencySymbol || 'GHS'}
                </span>
                <span className="amount">{product.price?.toFixed(2)}{isMeatProduct(product) ? <span style={{fontSize:'11px',fontWeight:'500',color:'#94a3b8'}}>/kg</span> : ''}</span>
              </>
            ) : (
              <button
                className="login-to-see-price"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = 'https://app.auroragh.com/login';
                }}
              >
                Login to see price
              </button>
            )}
          </div>

          {canAddToCart ? (
            <button
              className="add-to-cart-btn"
              onClick={handleAddToCart}
              disabled={product.stockQuantity === 0}
            >
              <ShoppingCart size={16} />
              {product.stockQuantity === 0 ? 'Out of Stock' : 'Add'}
            </button>
          ) : (
            <button
              className="login-to-cart-btn"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = 'https://app.auroragh.com/login';
              }}
            >
              <ShoppingCart size={16} />
              Login
            </button>
          )}
        </div>

        {product.stockQuantity > 0 && product.stockQuantity <= 5 && (
          <p className="low-stock">Only {product.stockQuantity} left</p>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;